<horizon-menubar hostAppName="OMS Management" [items]="items()" [userName]="userName()"
				 (logout)="handleLogout()"></horizon-menubar>
